module.exports = __webpack_public_path__ + "img/jo3.3249b0fa.png";